<div class="cx-summary-heading">
  {{ 'orderCost.orderSummary' | cxTranslate }}
</div>

@if (cart) {
  <div class="cx-summary-partials">
    @if (!usjfeature) {
      <div class="cx-summary-row">
        <div class="col-6 cx-summary-label">
          {{ 'orderCost.subt' | cxTranslate }}
        </div>
        <div class="col-4 cx-summary-amount">
          {{ cart.subTotal?.formattedValue }}
        </div>
      </div>
      @if (cart.totalDiscounts) {
        @if (cart.totalDiscounts!.value != 0) {
          <div class="cx-summary-row">
            <div class="col-6 cx-summary-label">
              {{ 'orderCost.discounts' | cxTranslate }}
            </div>
            <div class="col-4 cx-summary-amount">
              {{ cart.totalDiscounts!.formattedValue }}
            </div>
          </div>
        }
      }
      @if (multiTaxEnabled) {
        <!--for lv and site where multitax is enabled -->
        @for (tax of cart.taxes; track tax.taxCode) {
          @if (tax.taxAmount?.formattedValue) {
            <div class="cx-summary-row">
              <div class="col-6 cx-summary-label">
                {{ tax.taxName }}
              </div>
              <div class="col-4 cx-summary-amount">
                {{ tax.taxAmount?.formattedValue }}
              </div>
            </div>
          }
        }
      } @else {
        <!--for uor and ukr -->
        @if (cart.totalTax?.formattedValue && !ushSite) {
          <div class="cx-summary-row">
            <div class="col-6 cx-summary-label">
              {{ 'orderCost.salesTax' | cxTranslate }}
            </div>
            <div class="col-4 cx-summary-amount">
              {{ cart.totalTax?.formattedValue }}
            </div>
          </div>
        }
      }
    }
    <!--for usj -->
    <div class="cx-summary-row cx-summary-total">
      <div class="col-6 cx-summary-label">
        {{ 'orderCost.total' | cxTranslate }}
      </div>
      <div class="col-4 cx-summary-amount">
        {{ cart.totalPriceWithTax?.formattedValue }}
      </div>
    </div>
    <!-- <ng-template #cartWithoutNet> </ng-template> -->
  </div>
}

<ng-container *cxFeatureLevel="'1.3'">
  <cx-applied-coupons [vouchers]="$any(cart.appliedVouchers)" [isReadOnly]="true"></cx-applied-coupons>
</ng-container>
